export default __webpack_public_path__ + "static/img/logo.5887114.png";